import styled from "styled-components";

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing * 4}px;
  &.margin-top {
    margin-top: ${({ theme }) => theme.spacing * 6}px;
  }
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  color: ${({ theme }) => theme.colors.gray[900]};
`;
